import { render, staticRenderFns } from "./InviteSetting.vue?vue&type=template&id=006c2e88&scoped=true&"
import script from "./InviteSetting.vue?vue&type=script&lang=ts&"
export * from "./InviteSetting.vue?vue&type=script&lang=ts&"
import style0 from "./InviteSetting.vue?vue&type=style&index=0&id=006c2e88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006c2e88",
  null
  
)

export default component.exports